import { useGetMotivationDiagnosisQuery } from '../../../api/ua-insights'
import { useUAInsightsScope } from './useUAInsightsNavigation'

/**
 * Fetches the per-card Blind Spot / Alignment detail for a motivation against
 * the source game. Returns `undefined` when either input is null so callers
 * can pass URL params straight in without branching at the call site.
 */
export const useMotivationDiagnosisDetail = (motivationId: string | null, gameId: string | null) => {
  const { networkId, month } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetMotivationDiagnosisQuery(
    {
      motivationId: motivationId ?? '',
      gameId: gameId ?? '',
      networkId: networkId ?? undefined,
      month: month ?? undefined,
    },
    { skip: !motivationId || !gameId }
  )
  return { data, isLoading: isFetching, isError, refetch }
}
